// @ts-nocheck
import axios from '../utils/axios';
import { ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT, ONLINE_REPORT_SERVICE_API_ENDPOINT } from '../config';
import { catchAsync } from '../utils/api';

const getLogs = catchAsync(async ({ query: params }) => {
    const result = await axios.get(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/transactions`, { params });

    return result.data;
});

const getOperationLogs = catchAsync(async ({ query: params }) => {
    const result = await axios.get(`${ONLINE_REPORT_SERVICE_API_ENDPOINT}/operation/logs`, { params });

    return result.data;
});

const getAuditLogs = catchAsync(async ({ query: params }) => {
    const result = await axios.get(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/audit-logs`, { params });

    return result.data;
});

const LogsService = {
    getLogs,
    getOperationLogs,
    getAuditLogs,
};

export default LogsService;
